import { render, staticRenderFns } from "./SearchResultDetail.vue?vue&type=template&id=8bd6440c&scoped=true&"
import script from "./SearchResultDetail.vue?vue&type=script&lang=js&"
export * from "./SearchResultDetail.vue?vue&type=script&lang=js&"
import style0 from "./SearchResultDetail.vue?vue&type=style&index=0&id=8bd6440c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bd6440c",
  null
  
)

export default component.exports